import DOMPurify from 'dompurify'

// https://github.com/cure53/DOMPurify
export function install(app) {
  app.directive('sanitize', (el, binding) => {
    if (binding.value !== binding.oldValue) {
      if (Array.isArray(binding.value)) {
        el.innerHTML = DOMPurify.sanitize(binding.value[0], binding.value[1])
      }
      else {
        // if (binding.modifiers.strip) {
        //     el.innerHTML = sanitizeHtml(binding.value, FILTER_STRIP)
        // } else if (binding.modifiers.basic) {
        //     el.innerHTML = sanitizeHtml(binding.value, options1)
        // } else if (binding.modifiers.inline) {
        //     el.innerHTML = sanitizeHtml(binding.value, FILTER_INLINE)
        // } else if (binding.modifiers.nothing) {
        //     el.innerHTML = sanitizeHtml(binding.value, FILTER_NOTHING)
        // } else {
        el.innerHTML = DOMPurify.sanitize(binding.value)
        // }
      }
    }
  })
}
